import UserStatusEnum from '@constants/enums/user/status';

import i18n from '@plugins/i18n';

import { Collection, Adviser } from '@/models';

export class ProviderAdviserCollection extends Collection {
    static type = 'ProviderAdviserCollection';
    static endpoint = Adviser.api.index;
    static model = Adviser;

    get headers() {
        return [
            this.createHeader('name', i18n.t('name'), {
                width: '18rem',
                minWidth: '18rem',
                sortable: true,
                sticky: true
            }),
            this.createHeader('status', i18n.t('status'), {
                filterable: false,
                sortable: false,
                width: '10rem',
                format: 'enum',
                enum: UserStatusEnum,
                enumA11yKey: 'enums.user_status',
                enumTypes: {
                    [UserStatusEnum.ACTIVE]: 'success',
                    [UserStatusEnum.INACTIVE]: 'grey',
                    [UserStatusEnum.SUSPENDED]: 'error',
                    [UserStatusEnum.UNVERIFIED]: 'warning'
                }
            }),
            this.createHeader('gi_ref', i18n.t('gi_ref'), {
                width: '9rem'
            }),
            this.createHeader('fca_number', i18n.t('fca_number'), {
                width: '12rem'
            }),
            this.createHeader('company_info.company_number', i18n.t('company_number'), {
                path: 'company_info.company_number',
                width: '12rem'
            }),
            this.createHeader('mutual_client_count', i18n.t('mutual_clients'), {
                filterable: false,
                sortable: false,
                width: '10rem',
                format: 'number'
            })
        ];
    }
}

export default ProviderAdviserCollection;
